import { api } from "./client";
import type { User } from "@/types";

export interface TokenResponse {
  access_token: string;
  token_type: "Bearer";
  expires_in: number;
}

export const authApi = {
  devLogin: (email: string, displayName?: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/dev-login",
      { email, display_name: displayName },
      { skipRefresh: true },
    ),
  /** Doc 47: Native register email + password. */
  register: (email: string, password: string, displayName?: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/register",
      { email, password, display_name: displayName },
      { skipRefresh: true },
    ),
  /** Doc 47: Native login email + password (primary). */
  login: (email: string, password: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/login",
      { email, password },
      { skipRefresh: true },
    ),
  /** Login với credential Odoo thật. Backward compat — chỉ dùng nếu user đã link Odoo. */
  odooLogin: (username: string, password: string, odooDb?: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/odoo-login",
      { username, password, odoo_db: odooDb },
      { skipRefresh: true },
    ),
  /** Doc 50: Preview invite token before user submits password. */
  setupAccountPreview: (token: string) =>
    api.get<{
      email: string;
      display_name: string | null;
      expires_in_seconds: number | null;
    } | null>("/api/v1/auth/setup-account/preview", {
      query: { token },
      skipRefresh: true,
    }),
  /** Doc 50: Consume invite token + set password → auto-login. */
  setupAccount: (token: string, password: string, displayName?: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/setup-account",
      { token, password, display_name: displayName },
      { skipRefresh: true },
    ),
  /** Doc 54: Request password reset (anti-enumeration: always 200). */
  forgotPassword: (email: string) =>
    api.post<{ ok: boolean; message: string }>(
      "/api/v1/auth/forgot-password",
      { email },
      { skipRefresh: true },
    ),
  /** Doc 54: Preview reset token before user submits new password. */
  resetPasswordPreview: (token: string) =>
    api.get<{ email: string; expires_in_seconds: number | null } | null>(
      "/api/v1/auth/reset-password/preview",
      { query: { token }, skipRefresh: true },
    ),
  /** Doc 54: Consume reset token + set new password → auto-login. */
  resetPassword: (token: string, password: string) =>
    api.post<TokenResponse>(
      "/api/v1/auth/reset-password",
      { token, password },
      { skipRefresh: true },
    ),
  refresh: () =>
    api.post<TokenResponse>(
      "/api/v1/auth/refresh",
      {},
      { skipRefresh: true },
    ),
  logout: () => api.post<void>("/api/v1/auth/logout"),
  logoutAll: () => api.post<void>("/api/v1/auth/logout-all"),
  me: () => api.get<User>("/api/v1/auth/me"),
};
